import React, { createContext, useContext, useEffect, useRef } from 'react';
import { GraphService } from './graph.service';
import { IGraphProps } from './types';

const GraphContext = createContext<GraphService | null>(null);

export const useGraphContext = (): GraphService => {
  const ctx = useContext(GraphContext);

  if (!ctx) {
    throw new Error('useGraphContext must be used within a GraphProvider');
  }

  return ctx;
};

export const GraphProvider: React.FC<React.PropsWithChildren<IGraphProps>> = ({ children, ...props }) => {
  const ref = useRef(new GraphService());

  useEffect(() => {
    ref.current.updateProps(props);
  }, [props]);

  return <GraphContext.Provider value={ref.current}>{children}</GraphContext.Provider>;
};
